export default "__VITE_ASSET__D2qgly1m__"